module.exports = __webpack_public_path__ + "img/medical-info.3e259669.svg";